import { createReducer, on } from '@ngrx/store';
import * as fromData from './data.actions';
import { Document } from './data.model';
import { View } from '../workflow/workflow.model';
import { DocumentQueryParams, QueryParams } from 'src/app/modules/core/store/models/query.model';

export const dataFeatureKey = 'data';

export interface State {
  documents?: Document[] | null;
  documentForDelete?: Document;
  selectedDocument?: Document;
  editDocumentView?: View;
  queryParams?: DocumentQueryParams | null;
  searchTerm: string | null;
  docsExistsInStep?: boolean;
  err?: any;
  ui?: {
    isWorking?: boolean;
    showEditDocument?: boolean;
    isNewDocument?: boolean;
  };
}

export const initialState: State = {
  documents: [],
  documentForDelete: null,
  docsExistsInStep: false,
  queryParams: {
    pagination: {
      skip: 0,
      take: 10
    },
    fields: null,
    filterGroup: null,
    calcFields: null
  },
  searchTerm: null,
  err: null,
  ui: {
    isWorking: false,
    showEditDocument: false,
    isNewDocument: false
  }
};

export const reducer = createReducer(
  initialState,
  on(fromData.getDocumentsComplete, (state, action) => {
    if (!action.results) {
      return {
        ...state
      };
    }

    const { data, skip, take, totalCount } = action.results;

    return {
      ...state,
      documents: data,
      documentForDelete: null,
      queryParams: {
        ...state.queryParams,
        skip,
        take,
        totalCount
      },
      err: null,
      ui: {
        ...state.ui,
        isNewDocument: false,
        isWorking: false,
        showEditDocument: false
      }
    };
  }),
  on(fromData.newDocumentComplete, (state, action) => {
    return {
      ...state,
      editDocumentView: action.view,
      selectedDocument: action.document,
      err: null,
      ui: {
        ...state.ui,
        isNewDocument: true,
        isWorking: false,
        showEditDocument: true
      }
    };
  }),
  on(fromData.setError, (state, action) => {
    return {
      ...state,
      err: action.err,
      ui: {
        ...state.ui,
        isWorking: false
      }
    };
  }),
  on(fromData.editDocumentComplete, (state, action) => {
    return {
      ...state,
      editDocumentView: action.view,
      selectedDocument: action.document,
      err: null,
      ui: {
        ...state.ui,
        isNewDocument: false,
        isWorking: false,
        showEditDocument: true
      }
    };
  }),
  on(fromData.cancelEditDocument, (state, action) => {
    return {
      ...state,
      editDocumentView: null,
      selectedDocument: null,
      err: null,
      ui: {
        ...state.ui,
        isNewDocument: false,
        isWorking: false,
        showEditDocument: false
      }
    };
  }),
  on(fromData.setDocumentForDelete, (state, action) => {
    return {
      ...state,
      documentForDelete: action.document
    };
  }),
  on(fromData.clearDocumentForDelete, (state, action) => {
    return {
      ...state,
      documentForDelete: null
    };
  }),
  on(fromData.setDocumentQueryParams, (state, action) => {
    return {
      ...state,
      queryParams: action.query
    };
  }),
  on(fromData.setSearchTerm, (state, { searchTerm }) => ({
    ...state,
    searchTerm
  })),
  on(fromData.paginateList, (state, { skip }) => ({
    ...state,
    queryParams: {
      ...state.queryParams,
      pagination: {
        ...state.queryParams.pagination,
        skip
      }
    }
  })),
  on(fromData.resetState, () => ({ ...initialState }))
);

export const getCurrentDocuments = (state: State) => state?.documents;

export const getQueryParams = (state: State) => state?.queryParams;

export const getSearchTerm = (state: State) => state?.searchTerm;

export const getDocumentForDelete = (state: State) => state?.documentForDelete;

export const getShowEditDocument = (state: State) => state?.ui?.showEditDocument;

export const getIsWorking = (state: State) => state?.ui?.isWorking;

export const getIsNewDocument = (state: State) => state?.ui?.isNewDocument;

export const getSelectedDocument = (state: State) => state?.selectedDocument;

export const getEditDocumentView = (state: State) => state?.editDocumentView;

export const getdocsExistsInStep = (state: State) => state?.docsExistsInStep;
